<template>
  <div id="app">
    <Header v-if="!$route.meta.plainLayout"></Header>
    <router-view
      :style="{
        marginTop: !$route.meta.plainLayout ? '0' : '0',
        minHeight: '100vh',
        boxSizing: 'border-box',
      }"
    />
    <Footer v-if="!$route.meta.plainLayout"></Footer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import * as Cookies from "tiny-cookie";
import Header from "@/components/header";
import Footer from "@/components/footer";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters({
      hasAuthentication: "hasAuthentication",
    }),
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        this.getArticleCategories();
      },
    },
  },
  methods: {
    ...mapMutations({
      setAuthentication: "setAuthentication",
    }),
    ...mapActions({
      deleteAuthentication: "deleteAuthentication",
      getAuthenticationUser: "getAuthenticationUser",
      getUserOrganization: "getUserOrganization",
      getOrganizationExhibitor: "getOrganizationExhibitor",
      getCollecteds: "getCollecteds",
      getLikeds: "getLikeds",
      getVenues: "getVenues",
      getExhibitCategories: "getExhibitCategories",
      getArticleCategories: "getArticleCategories",
    }),
  },
  async mounted() {
    this.getVenues();
    this.getExhibitCategories();
    this.getArticleCategories();

    const authentication = this.$cookies.get("authentication");

    console.log("-------------------------------");
    console.log(authentication);
    console.log(this.hasAuthentication());
    console.log("-------------------------------");

    // if (authentication) {
    //   this.setAuthentication(authentication);

    //   await this.getAuthenticationUser();
    //   // await this.getAuthenticationAccount();

    //   if (this.user.organization && this.user.organization.id) {
    //     await this.getUserOrganization();
    //     await this.getOrganizationExhibitor();
    //   }
    // } else {
    //   this.deleteAuthentication();
    // }

    if (this.hasAuthentication()) {
      this.getCollecteds();
      this.getLikeds();
    }
  },
};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/App.vue